// 特定の高さまでスクロールされてからボタンを追従するように
  $(function() {
    var $fixElement = $('.last-cv'); // 追従する要素
    var baseFixPoint = $fixElement.offset().top; // 追従する要素の初期位置
    var fixClass = 'last-cv--fixed'; // 追従時に付与するclass
 
    // 要素が追従する処理
    function fixFunction() {
        var windowScrolltop = $(window).scrollTop();
        // スクロールが初期位置を通過しているとき
        if(windowScrolltop >= baseFixPoint) {
            $fixElement.addClass(fixClass);
        } else {
            $fixElement.removeClass(fixClass);
        }
    }
 
    $(window).on('load scroll', function() {
        fixFunction();
    });
});

$(function() {
  var windowSize = $(window).width();
  if (windowSize < 768) {
    $('.last-cv').addClass('js-sp-article-fixed-footer');
    var spFixElement = $('.js-sp-article-fixed-footer');    
    spFixElement.hide();
    //スクロールが100に達したらボタン表示
    $(window).scroll(function () {
        if ($(this).scrollTop() > 600) {
            spFixElement.fadeIn(600);
        } else {
            spFixElement.fadeOut(600);
        }
    });
  }
});